/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why use the Pomodoro Technique?`)
};

const es_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué usar la Técnica Pomodoro?`)
};

const de_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum die Pomodoro-Technik nutzen?`)
};

const nl_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom de Pomodoro-techniek gebruiken?`)
};

const fr_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi utiliser la technique Pomodoro ?`)
};

const it_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché usare la tecnica del Pomodoro?`)
};

const pt_br2_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que usar a Técnica Pomodoro?`)
};

const pt_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê usar a Técnica Pomodoro?`)
};

const ja_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜポモドーロ・テクニックを使うのですか？`)
};

const zh_timer_pomodoro_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么要使用番茄工作法？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_faq2_q", locale)
	if (locale === "en") return en_timer_pomodoro_faq2_q(inputs)
	if (locale === "es") return es_timer_pomodoro_faq2_q(inputs)
	if (locale === "de") return de_timer_pomodoro_faq2_q(inputs)
	if (locale === "nl") return nl_timer_pomodoro_faq2_q(inputs)
	if (locale === "fr") return fr_timer_pomodoro_faq2_q(inputs)
	if (locale === "it") return it_timer_pomodoro_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_faq2_q(inputs)
	if (locale === "pt") return pt_timer_pomodoro_faq2_q(inputs)
	if (locale === "ja") return ja_timer_pomodoro_faq2_q(inputs)
	return zh_timer_pomodoro_faq2_q(inputs)
};